import { Box, Button, Tab, Tabs } from '@mui/material';
import { FunctionComponent, SyntheticEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { TabPanel } from '../../../components/TabPanel/TabPanel';
import { useCurrentEventQuery } from '../../../event/hooks/useCurrentEventQuery';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { MyTargetedUsersTab } from './components/MyTargetedUsersTab/MyTargetedUsersTab';
import { TargetedUsersTab } from './components/TargetedUsersTab/TargetedUsersTab';
import { UserTargetsTab } from './components/UserTargetsTab/UserTargetsTab';

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

export const TargetedUsers: FunctionComponent = () => {
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  const { data: currentEventData } = useCurrentEventQuery();
  const navigate = useNavigate();

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setCurrentTabIndex(newValue);
  };

  if (!currentEventData?.currentEvent) {
    return null;
  }

  return (
    <Layout title="Target leaderboard" activeTab="target">
      <Button variant="outlined" onClick={() => navigate('/target')}>
        Retour au swipe
      </Button>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={currentTabIndex}
          onChange={handleChange}
          aria-label="Target tabs"
        >
          <Tab label="Leaderboard" {...a11yProps(0)} />
          <Tab label="Mes targets" {...a11yProps(1)} />
          <Tab label="Ceux qui veulent ma mort" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={currentTabIndex} index={0}>
        <TargetedUsersTab eventId={currentEventData.currentEvent.id} />
      </TabPanel>
      <TabPanel value={currentTabIndex} index={1}>
        <MyTargetedUsersTab eventId={currentEventData.currentEvent.id} />
      </TabPanel>
      <TabPanel value={currentTabIndex} index={2}>
        <UserTargetsTab eventId={currentEventData.currentEvent.id} />
      </TabPanel>
    </Layout>
  );
};
